<script>
  import { statusLabel, statusBadgeClass, statusTooltip } from '../lib/labels.js';
  import { isExpectedMancataConsegna } from '../lib/expected-mancata-consegna.js';
  import { t } from '../i18n/index.js';
  import InfoHint from './InfoHint.svelte';

  // Consistent invoice-status badge: Italian label + colour + plain-Italian
  // tooltip, identical on every screen.
  export let status = '';
  export let size = ''; // '' | 'lg'
  // The whole invoice, when the caller has it. A mancata consegna with no
  // codice destinatario and no PEC is the expected outcome and is shown
  // neutrally; a badge given only a status keeps the status colour.
  export let invoice = null;
  // A help toggle beside the badge, for a page that shows one status on its
  // own (the invoice header). Lists use <StatusLegend> instead: one
  // disclosure for the page, not a button on every row.
  export let help = false;

  $: expected = isExpectedMancataConsegna(invoice ? { ...invoice, status } : null);
  $: label = expected ? $t('invoices.expectedMancataConsegna.label') : statusLabel(status);
  $: badgeClass = expected ? 'badge-gray' : statusBadgeClass(status);
  $: tip = expected ? $t('invoices.expectedMancataConsegna.help') : statusTooltip(status);
</script>

<!-- whitespace-normal: a long label ("Disponibile nell'area riservata") wraps
     inside a capped cell instead of widening the whole column. -->
{#if help && tip}
  <span class="inline-flex items-center gap-1">
    <span class="badge whitespace-normal {badgeClass} {size === 'lg' ? 'badge-lg' : ''}" title={tip}>{label}</span>
    <InfoHint text={`${label}: ${tip}`} />
  </span>
{:else}
  <span
    class="badge whitespace-normal {badgeClass} {size === 'lg' ? 'badge-lg' : ''}"
    title={tip || null}
  >{label}</span>
{/if}
